"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authServiceWatchers = authServiceWatchers;
exports.clearGuestToken = clearGuestToken;
var _effects = require("redux-saga/effects");
var _sagas = require("../../auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* authSendOtp(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_SEND_OTP_API.request());
    const mainResponse = yield (0, _effects.call)(api.authSendOtp, requestParams);
    yield (0, _effects.put)(actions.AUTH_SEND_OTP_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_SEND_OTP_API.failure(err));
    onFailure(err);
  }
}
function* authVerifyOtp(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_VERIFY_OTP_API.request());
    const mainResponse = yield (0, _effects.call)(api.authVerifyOtp, requestParams);
    yield (0, _effects.put)(actions.AUTH_VERIFY_OTP_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_VERIFY_OTP_API.failure(err));
    onFailure(err);
  }
}
function* authResendOtp(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_RESEND_OTP_API.request());
    const mainResponse = yield (0, _effects.call)(api.authResendOtp, requestParams);
    yield (0, _effects.put)(actions.AUTH_RESEND_OTP_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_RESEND_OTP_API.failure(err));
    onFailure(err);
  }
}
function* authUserRegister(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_USER_REGISTER_API.request());
    const mainResponse = yield (0, _effects.call)(api.authUserRegister, requestParams);
    yield (0, _effects.put)(actions.AUTH_USER_REGISTER_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_USER_REGISTER_API.failure(err));
    onFailure(err);
  }
}
function* authUserLogOut(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_USER_LOG_OUT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.authUserLogOut, requestParams, tokenData);
    yield (0, _effects.put)(actions.AUTH_USER_LOG_OUT_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_USER_LOG_OUT_API.failure(err));
    onFailure(err);
  }
}
function* authRefreshToken(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_REFRESH_TOKEN_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.authRefreshToken, requestParams, tokenData);
    yield (0, _effects.put)(actions.AUTH_REFRESH_TOKEN_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_REFRESH_TOKEN_API.failure(err));
    onFailure(err);
  }
}
function* authVerifyEmail(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_VERIFY_EMAIL_API.request());
    const mainResponse = yield (0, _effects.call)(api.authVerifyEmail, requestParams);
    yield (0, _effects.put)(actions.AUTH_VERIFY_EMAIL_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_VERIFY_EMAIL_API.failure(err));
    onFailure(err);
  }
}
function* authVerifyEmailPassword(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_VERIFY_EMAIL_PASSWORD_API.request());
    const mainResponse = yield (0, _effects.call)(api.authVerifyEmailPassword, requestParams);
    yield (0, _effects.put)(actions.AUTH_VERIFY_EMAIL_PASSWORD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_VERIFY_EMAIL_PASSWORD_API.failure(err));
    onFailure(err);
  }
}
function* authResendEmailPassword(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_RESEND_EMAIL_PASSWORD_API.request());
    const mainResponse = yield (0, _effects.call)(api.authResendEmailPassword, requestParams);
    yield (0, _effects.put)(actions.AUTH_RESEND_EMAIL_PASSWORD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_RESEND_EMAIL_PASSWORD_API.failure(err));
    onFailure(err);
  }
}
function* authSetEmailPassword(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_SET_EMAIL_PASSWORD_API.request());
    const mainResponse = yield (0, _effects.call)(api.authSetEmailPassword, requestParams);
    yield (0, _effects.put)(actions.AUTH_SET_EMAIL_PASSWORD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_SET_EMAIL_PASSWORD_API.failure(err));
    onFailure(err);
  }
}
function* authForgotEmailPassword(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_FORGOT_EMAIL_PASSWORD_API.request());
    const mainResponse = yield (0, _effects.call)(api.authForgotEmailPassword, requestParams);
    yield (0, _effects.put)(actions.AUTH_FORGOT_EMAIL_PASSWORD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_FORGOT_EMAIL_PASSWORD_API.failure(err));
    onFailure(err);
  }
}
function* authUpdateEmail(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_UPDATE_EMAIL_API.request());
    const mainResponse = yield (0, _effects.call)(api.authUpdateEmail, requestParams);
    yield (0, _effects.put)(actions.AUTH_UPDATE_EMAIL_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_UPDATE_EMAIL_API.failure(err));
    onFailure(err);
  }
}
function* authVerifyUaePass(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_VERIFY_UAE_PASS_API.request());
    const mainResponse = yield (0, _effects.call)(api.authVerifyUaePass, requestParams);
    yield (0, _effects.put)(actions.AUTH_VERIFY_UAE_PASS_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_VERIFY_UAE_PASS_API.failure(err));
    onFailure(err);
  }
}
function* authVerifyBiometric(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_VERIFY_BIOMETRIC_API.request());
    const mainResponse = yield (0, _effects.call)(api.authVerifyBiometric, requestParams);
    yield (0, _effects.put)(actions.AUTH_VERIFY_BIOMETRIC_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_VERIFY_BIOMETRIC_API.failure(err));
    onFailure(err);
  }
}
function* authEnableBiometric(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_ENABLE_BIOMETRIC_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.authEnableBiometric, requestParams, tokenData);
    yield (0, _effects.put)(actions.AUTH_ENABLE_BIOMETRIC_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_ENABLE_BIOMETRIC_API.failure(err));
    onFailure(err);
  }
}
function* authDisableBiometric(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_DISABLE_BIOMETRIC_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.authDisableBiometric, requestParams, tokenData);
    yield (0, _effects.put)(actions.AUTH_DISABLE_BIOMETRIC_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_DISABLE_BIOMETRIC_API.failure(err));
    onFailure(err);
  }
}
function* authNotYouRegistration(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_NOT_YOU_REGISTRATION_API.request());
    const mainResponse = yield (0, _effects.call)(api.authNotYouRegistration, requestParams);
    yield (0, _effects.put)(actions.AUTH_NOT_YOU_REGISTRATION_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_NOT_YOU_REGISTRATION_API.failure(err));
    onFailure(err);
  }
}
function* authGuestToken(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    var _mainResponse$body;
    yield (0, _effects.put)(actions.AUTH_GUEST_TOKEN_API.request());
    const mainResponse = yield (0, _effects.call)(api.authGuestToken, requestParams);
    const guestTokenData = {
      accessToken: mainResponse === null || mainResponse === void 0 || (_mainResponse$body = mainResponse.body) === null || _mainResponse$body === void 0 ? void 0 : _mainResponse$body.guestToken
    };
    yield (0, _effects.put)(actions.AUTH_GUEST_TOKEN_API.success(guestTokenData));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_GUEST_TOKEN_API.failure(err));
    onFailure(err);
  }
}
function* clearGuestToken() {
  try {
    yield (0, _effects.put)(actions.AUTH_GUEST_TOKEN_API.success());
  } catch (err) {}
}
function* authUpdateEmailPassword(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_UPDATE_EMAIL_PASSWORD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.authUpdateEmailPassword, requestParams, tokenData);
    yield (0, _effects.put)(actions.AUTH_UPDATE_EMAIL_PASSWORD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_UPDATE_EMAIL_PASSWORD_API.failure(err));
    onFailure(err);
  }
}
function* authCreateEmailPassword(params) {
  const {
    onSuccess,
    onFailure,
    requestParams
  } = params.data;
  try {
    yield (0, _effects.put)(actions.AUTH_CREATE_EMAIL_PASSWORD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.authCreateEmailPassword, requestParams, tokenData);
    yield (0, _effects.put)(actions.AUTH_CREATE_EMAIL_PASSWORD_API.success(mainResponse));
    onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.AUTH_CREATE_EMAIL_PASSWORD_API.failure(err));
    onFailure(err);
  }
}
function* authServiceWatchers() {
  yield (0, _effects.takeLatest)(actions.AUTH_SEND_OTP, authSendOtp);
  yield (0, _effects.takeLatest)(actions.AUTH_VERIFY_OTP, authVerifyOtp);
  yield (0, _effects.takeLatest)(actions.AUTH_RESEND_OTP, authResendOtp);
  yield (0, _effects.takeLatest)(actions.AUTH_USER_REGISTER, authUserRegister);
  yield (0, _effects.takeLatest)(actions.AUTH_USER_LOG_OUT, authUserLogOut);
  yield (0, _effects.takeLatest)(actions.AUTH_REFRESH_TOKEN, authRefreshToken);
  yield (0, _effects.takeLatest)(actions.AUTH_VERIFY_EMAIL, authVerifyEmail);
  yield (0, _effects.takeLatest)(actions.AUTH_VERIFY_EMAIL_PASSWORD, authVerifyEmailPassword);
  yield (0, _effects.takeLatest)(actions.AUTH_RESEND_EMAIL_PASSWORD, authResendEmailPassword);
  yield (0, _effects.takeLatest)(actions.AUTH_SET_EMAIL_PASSWORD, authSetEmailPassword);
  yield (0, _effects.takeLatest)(actions.AUTH_FORGOT_EMAIL_PASSWORD, authForgotEmailPassword);
  yield (0, _effects.takeLatest)(actions.AUTH_UPDATE_EMAIL, authUpdateEmail);
  yield (0, _effects.takeLatest)(actions.AUTH_VERIFY_UAE_PASS, authVerifyUaePass);
  yield (0, _effects.takeLatest)(actions.AUTH_VERIFY_BIOMETRIC, authVerifyBiometric);
  yield (0, _effects.takeLatest)(actions.AUTH_ENABLE_BIOMETRIC, authEnableBiometric);
  yield (0, _effects.takeLatest)(actions.AUTH_DISABLE_BIOMETRIC, authDisableBiometric);
  yield (0, _effects.takeLatest)(actions.AUTH_NOT_YOU_REGISTRATION, authNotYouRegistration);
  yield (0, _effects.takeLatest)(actions.AUTH_GUEST_TOKEN, authGuestToken);
  yield (0, _effects.takeLatest)(actions.CLEAR_GUEST_TOKEN, clearGuestToken);
  yield (0, _effects.takeLatest)(actions.AUTH_UPDATE_EMAIL_PASSWORD, authUpdateEmailPassword);
  yield (0, _effects.takeLatest)(actions.AUTH_CREATE_EMAIL_PASSWORD, authCreateEmailPassword);
}